import React, { useEffect, ReactNode } from 'react';
import { useAuth } from '@nimbitlabs/auth';
import { useNotificationsStore } from './notificationsStore';

interface NotificationProviderProps {
  children: ReactNode;
}

export function NotificationProvider({ children }: NotificationProviderProps) {
  const { user } = useAuth();
  const fetchNotifications = useNotificationsStore((state) => state.fetchNotifications);

  useEffect(() => {
    if (user) {
      // Initial fetch
      fetchNotifications();
      
      // Poll every 30 seconds
      const interval = setInterval(() => {
        fetchNotifications();
      }, 30000);
      
      return () => clearInterval(interval);
    }
  }, [user, fetchNotifications]);

  return <>{children}</>;
}
